import React, { Fragment } from 'react';
import pt from 'prop-types';
import { Field, Fieldtable } from 'components/form';
import { currencyOptions } from 'utils/geo';
import { currencyName } from 'utils/money';

export default class PartnerCurrencies extends React.PureComponent {
  static propTypes = {
    defaultValue: pt.array,
  };

  renderHeading = () => [
    <th key="1" width="100%">
      Currencies
    </th>,
  ];

  renderValue = ({ value }) => [
    <td key="1">
      <span>
        {value.name} ({value.code})
      </span>
    </td>,
  ];

  renderForm = (values, index, allValues) => {
    const disabledOptions = allValues
      .filter((_, i) => i !== +index)
      .map((c) => c.code);

    return (
      <Fragment>
        <Field
          type="select"
          name="code"
          label="Currency"
          options={currencyOptions}
          defaultValue={values.code}
          disabledOptions={disabledOptions}
          required={true}
          className="span4"
        />
      </Fragment>
    );
  };

  onSubmitModal = (values) => {
    if (!values.name) {
      values.name = currencyName(values.code);
    }
  };

  render() {
    const { defaultValue } = this.props;

    return (
      <Fieldtable
        label="Currency"
        name="partner.currencies"
        className="partner-fieldtable"
        onSubmitModal={this.onSubmitModal}
        defaultValue={defaultValue}
        renderHeading={this.renderHeading}
        renderValue={this.renderValue}
        renderForm={this.renderForm}
        sortable={false}
        removable={true}
      />
    );
  }
}
